export class PendingEverifyItem {
  everifyCaseQueueId:string
  everifyCaseId: string;
  everifyCaseNumber: string;
  firstName: string;
  lastName: string;
  ssn: string;
  locationName: string;
  caseStatus: EVerifyStatus;
  caseStatusDisplay: string;
  caseEligibilityStatement: EVerifyCaseEligibilityStatementStatus;
  dhsReferralStatus: EVerifySubStatus;
  ssaReferralStatus: EVerifySubStatus;
  isUserActionRequired: boolean;
  actionRequiredToResolveDuplicateCase: boolean;
  duplicateCaseId:string;
  pendingUserAction: string;
  pendingSystemAction: string;
  caseCreationStatus: EVerifyQueueStatus;
  caseCreationError:string;
  i9FormId: string;
  updatedAt?: Date;
  createdAt?: Date;
  /** Creation was refused because the case is late and states no delay reason (VTK-2000). */
  awaitingDelayReason: boolean;

  constructor(
    everifyCaseQueueId:string,
    everifyCaseId: string,
    everifyCaseNumber: string,
    firstName: string,
    lastName: string,
    ssn: string,
    locationName: string,
    caseStatus: EVerifyStatus,
    caseStatusDisplay: string,
    caseEligibilityStatement: EVerifyCaseEligibilityStatementStatus,
    dhsReferralStatus: EVerifySubStatus,
    ssaReferralStatus: EVerifySubStatus,
    isUserActionRequired: boolean,
    actionRequiredToResolveDuplicateCase: boolean,
    duplicateCaseId:string,
    pendingUserAction: string,
    pendingSystemAction: string,
    caseCreationStatus: EVerifyQueueStatus,
    caseCreationError:string,
    i9FormId: string,
    updatedAt?: Date,
    createdAt?: Date,
    awaitingDelayReason = false
  ) {
    this.everifyCaseQueueId = everifyCaseQueueId;
    this.everifyCaseId = everifyCaseId;
    this.everifyCaseNumber = everifyCaseNumber;
    this.firstName = firstName;
    this.lastName = lastName;
    this.ssn = ssn;
    this.locationName = locationName;
    this.caseStatus = caseStatus;
    this.caseStatusDisplay = caseStatusDisplay;
    this.caseEligibilityStatement = caseEligibilityStatement;
    this.dhsReferralStatus = dhsReferralStatus;
    this.ssaReferralStatus = ssaReferralStatus;
    this.isUserActionRequired = isUserActionRequired;
    this.actionRequiredToResolveDuplicateCase = actionRequiredToResolveDuplicateCase;
    this.duplicateCaseId = duplicateCaseId;
    this.pendingUserAction = pendingUserAction;
    this.pendingSystemAction = pendingSystemAction;
    this.caseCreationStatus = caseCreationStatus;
    this.caseCreationError = caseCreationError;
    this.i9FormId = i9FormId;
    this.updatedAt = updatedAt;
    this.createdAt = createdAt;
    this.awaitingDelayReason = awaitingDelayReason;
  }
}

export enum EVerifyStatus {
  UNCONFIRMED_DATA = 'UNCONFIRMED_DATA',
  PHOTO_MATCH = 'PHOTO_MATCH',
  SCAN_AND_UPLOAD = 'SCAN_AND_UPLOAD',
  MANUAL_REVIEW = 'MANUAL_REVIEW',
  PENDING_REFERRAL = 'PENDING_REFERRAL',
  REFERRED = 'REFERRED',
  QUEUED = 'QUEUED',
  EMPLOYMENT_AUTHORIZED = 'EMPLOYMENT_AUTHORIZED',
  FINAL_NONCONFIRMATION = 'FINAL_NONCONFIRMATION',
  CLOSE_CASE_AND_RESUBMIT = 'CLOSE_CASE_AND_RESUBMIT',
  CLOSED = 'CLOSED',
}

export const EVerifyStatusDisplay = {
  [EVerifyStatus.UNCONFIRMED_DATA]: 'Unconfirmed Data',
  [EVerifyStatus.PHOTO_MATCH]: 'Photo Match',
  [EVerifyStatus.SCAN_AND_UPLOAD]: 'Scan and Upload',
  [EVerifyStatus.MANUAL_REVIEW]: 'Manual Review',
  [EVerifyStatus.PENDING_REFERRAL]: 'Pending Referral',
  [EVerifyStatus.REFERRED]: 'Referred',
  [EVerifyStatus.QUEUED]: 'Queued',
  [EVerifyStatus.EMPLOYMENT_AUTHORIZED]: 'Employment Authorized',
  [EVerifyStatus.FINAL_NONCONFIRMATION]: 'Final Nonconfirmation',
  [EVerifyStatus.CLOSE_CASE_AND_RESUBMIT]: 'Close Case and Resubmit',
  [EVerifyStatus.CLOSED]: 'Closed',
}

export enum EVerifySubStatus {
  PENDING_REFERRAL = 'PENDING_REFERRAL',
  REFERRED = 'REFERRED',
  CONTINUANCE = 'CONTINUANCE',
  RESOLVED = 'RESOLVED',
  NOT_REFERRED = 'NOT_REFERRED',
}

export const EVerifySubStatusDisplay = {
  [EVerifySubStatus.PENDING_REFERRAL]: 'Pending Referral',
  [EVerifySubStatus.REFERRED]: 'Referred',
  [EVerifySubStatus.CONTINUANCE]: 'Continuance',
  [EVerifySubStatus.RESOLVED]: 'Resolved',
  [EVerifySubStatus.NOT_REFERRED]: 'Not Referred',
}

export enum EVerifyCaseEligibilityStatementStatus {
  EMPLOYMENT_AUTHORIZED = 'EMPLOYMENT_AUTHORIZED',
  NOT_AUTHORIZED_EMPLOYMENT = 'NOT_AUTHORIZED_EMPLOYMENT',
  RESUBMIT_CASE = 'RESUBMIT_CASE',
  NO_SHOW = 'NO_SHOW',
  NO_ACTION_FNC = 'NO_ACTION_FNC',
}

export const EVerifyCaseEligibilityStatementStatusDisplay = {
  [EVerifyCaseEligibilityStatementStatus.EMPLOYMENT_AUTHORIZED]: 'Employment Authorized',
  [EVerifyCaseEligibilityStatementStatus.NOT_AUTHORIZED_EMPLOYMENT]: 'Employment Not Authorized',
  [EVerifyCaseEligibilityStatementStatus.RESUBMIT_CASE]: 'Resubmit Case',
  [EVerifyCaseEligibilityStatementStatus.NO_SHOW]: 'No Show',
  [EVerifyCaseEligibilityStatementStatus.NO_ACTION_FNC]: 'No Action FNC',
}

export enum EVerifyQueueStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}